'use client'

import { getBrandHref } from '@/_lib/brand-href'
import { BRAND_LOGO, BRAND_NAMES, FEATURED_BRANDS } from '@/_utils/Constants'
import { Link } from '@/i18n/navigation'
import { Box, Grid, HStack, Image, Text } from '@chakra-ui/react'
import { ShipperData } from '@/_service/shipper-category.service'

const BRANDS = Object.entries(FEATURED_BRANDS)
  // Hide Yoko Pizza from brand tabs
  .filter(([, shipperId]) => shipperId !== FEATURED_BRANDS.yokopizza)
  .map(([key, shipperId]) => ({
    shipperId,
    name: BRAND_NAMES[shipperId] || key,
    logo: BRAND_LOGO[shipperId],
  }))

export default function BrandTabs({
  data,
  activeBrandId,
}: {
  data?: ShipperData[]
  activeBrandId?: string
}) {
  const brands =
    data
      ?.map(({ shipper_id, shipper_name, shipper_logo }) => ({
        shipperId: shipper_id,
        name: shipper_name,
        logo: shipper_logo,
      }))
      .filter((e) => e.shipperId !== FEATURED_BRANDS.yokopizza) || BRANDS
  return (
    <Box rounded='24px' my={4}>
      <Grid
        templateColumns={{
          base: 'repeat(2, 1fr)',
          lg: `repeat(${BRANDS.length}, 1fr)`,
        }}
        gap={4}
      >
        {brands.map(({ shipperId, name, logo }) => {
          const isActive = shipperId === activeBrandId

          return (
            <Box
              key={shipperId}
              asChild
              h={{ base: '46px', lg: '52px' }}
              rounded='12px'
              display='flex'
              alignItems='center'
              justifyContent='center'
              bg={isActive ? 'primary' : 'gray.100'}
              color={isActive ? 'gray.100' : 'text'}
              _hover={{ bg: isActive ? 'primary' : 'gray.100' }}
              transition='background 0.2s'
            >
              <Link
                href={getBrandHref(shipperId)}
                aria-current={isActive ? 'page' : undefined}
              >
                <HStack gap={2}>
                  {logo && (
                    <Image
                      src={logo}
                      alt=''
                      w='28px'
                      h='28px'
                      objectFit='cover'
                      rounded='6px'
                    />
                  )}
                  <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight={600}>
                    {name}
                  </Text>
                </HStack>
              </Link>
            </Box>
          )
        })}
      </Grid>
    </Box>
  )
}
